import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmailSupportComponent } from './components/email-support/email-support.component';
import { DoctorListComponent } from './components/doctor-list/doctor-list.component';
import { FinnovaPaymentsComponent } from './components/finnova-payments/finnova-payments.component';

const routes: Routes = [
  {
    path: 'email-support',
    component: EmailSupportComponent
  },
  {
    path: 'doctor-list',
    component: DoctorListComponent
  }
  ,{
    path: 'finnova-payments',
    component: FinnovaPaymentsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SharedRoutingModule { }
